import { JuiceInspectionStore } from "stores/JuiceInspectionStore";
import { JuiceBullpenGroup } from "./JuiceBullpenGroup";

export class JuiceInspection extends JuiceBullpenGroup {
    static _store: JuiceInspectionStore;
}
